<template>
    <div>
        <NavbarOne/>

        <div class="py-16 sm:py-24">
            <div class="container">
                <div class="max-w-[710px] mx-auto text-center p-7 sm:p-10 lg:p-12">
                    <div>
                        <img :src="bg" alt="thank-you">
                    </div>
                    <h3 class="leading-[1.2] mt-4 md:mt-6 text-2xl md:text-[32px] font-bold text-title dark:text-white">
                        Thank you for your order
                    </h3>
                    <p v-if="orderNumber" class="mt-3 text-base sm:text-lg text-title dark:text-white">
                        Order Number: <span class="font-semibold">{{ orderNumber }}</span>
                    </p>
                    <p class="mt-3 text-base sm:text-lg text-paragraph dark:text-white">
                        {{ message }}
                    </p>
                    <div class="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
                        <a
                            v-if="invoiceUrl"
                            :href="invoiceUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="btn btn-outline min-w-[190px]"
                            data-text="Open invoice"
                        >
                            <span>Open invoice</span>
                        </a>
                        <router-link to="/" class="btn btn-solid min-w-[190px]" data-text="Back to home">
                            <span>Back to home</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <FooterOne/>

        <ScrollToTop/>
    </div>
</template>

<script setup>
    import { computed, onMounted } from 'vue';
    import { useRoute } from 'vue-router';

    import NavbarOne from '@/components/navbar/navbar-one.vue';
    import FooterOne from '@/components/footer/footer-one.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';

    import bg from '@/assets/img/thank-you.png'
    
    import Aos from 'aos';

    const route = useRoute();
    const orderNumber = computed(() => route.query.order || '');
    const invoiceUrl = computed(() => route.query.invoice || '');
    const customerMailSent = computed(() => route.query.customerMail === '1');
    const adminMailSent = computed(() => route.query.adminMail === '1');
    const message = computed(() => {
        if (customerMailSent.value && adminMailSent.value) {
            return 'Your order was saved and the invoice email has been sent successfully.';
        }

        if (invoiceUrl.value) {
            return 'Your order was saved, but email delivery is not confirmed yet. You can open the invoice directly here while we finish the mail setup.';
        }

        return 'Your order was saved successfully. We are still checking the email delivery setup.';
    });

    onMounted(() => {
        Aos.init();
    });
</script>
